const MODULE_KEY_CONNECTOR = '-'

export const getModuleMapKey = (clinicId: number, moduleName: string) =>
  `${moduleName}${MODULE_KEY_CONNECTOR}${clinicId}`

export const parseModuleMapKey = (moduleKey: string) => {
  const [moduleName, moduleClinicId] = moduleKey.split(MODULE_KEY_CONNECTOR)

  return {
    moduleName,
    moduleClinicId,
  }
}
